
export const EmptyBranch = () => (
    <div>
      <img
        src="/images/branchPhoto.png"
        alt="Empty Branch"
        style={{
          width: '80%',
          height: '80%',
          borderRadius: '20px',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          margin: 'auto',
        }}
      />
      <h6 style={{ fontSize: '35px', fontWeight: 'bold' }}>Falta configuraciones en tu compañía</h6>
      <h1 style={{ fontSize: '25px' }}>
        Tu usuario se encuentra registrado pero todavía no tienes una sucursal asignada, por favor
        comunícate con tu administrador
      </h1>
    </div>
  );
